import { useState } from 'react';
import styled from 'styled-components';

import { Button, Modal, Text } from '@desygner/ui-common-components';
import { useTranslation } from '@desygner/ui-common-translation';

const StyledTitleContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
`;

export interface SSORevalidateModalProps {
  onSSOLogin: () => void;
}

export function SSORevalidateModal({ onSSOLogin }: SSORevalidateModalProps) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <Modal data-testid="sso-revalidate-modal">
      <Text size={'DisplayMedium'}>{t('sso.revalidate_credentials.title')}</Text>
      <StyledTitleContainer>
        <Text size={'Body'}>{t('sso.revalidate_credentials.subtitle')}</Text>
      </StyledTitleContainer>
      <Button
        action="sso-revalidate"
        onClick={() => {
          setLoading(true);
          onSSOLogin();
        }}
        loading={loading}
        disabled={loading}
        label={
          loading
            ? t('sso.revalidate_credentials.button.loading')
            : t('sso.revalidate_credentials.button.title')
        }
      />
    </Modal>
  );
}
